define('home/templates/postReply',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"avatar\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},((stack1 = (depth0 != null ? depth0.user : depth0)) != null ? stack1.isRegistered : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(partials.userAvatar,(depth0 != null ? depth0.user : depth0),{"name":"userAvatar","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<span class=\"user\">\n<img data-role=\"user-avatar\" src=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.user : depth0)) != null ? stack1.avatar : stack1)) != null ? stack1.cache : stack1), depth0))
    + "\"/>\n</span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "style=\"margin-left: 0\"";
},"8":function(container,depth0,helpers,partials,data) {
    return "<div class=\"media-preview empty\" data-role=\"media-preview\"></div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return "<div class=\"post-actions\">\n<ul class=\"wysiwyg\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.displayMediaUploadButton : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>\n"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.user : depth0)) != null ? stack1.isRegistered : stack1),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    return "<li data-role=\"media-uploader\"></li>\n";
},"13":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {};

  return "<div class=\"logged-in\">\n<section>\n<div class=\"temp-post\" style=\"text-align: right\">\n<button class=\"btn\">\n"
    + container.escapeExpression(helpers.gettext.call(alias1,"Post as %(username)s",{"name":"gettext","hash":{"username":helpers.getPartial.call(alias1,"userSpan",(depth0 != null ? depth0.user : depth0),{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\n</button>\n</div>\n</section>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"alert error\" style=\"display:none\" role=\"alert\">\n<a class=\"close\" data-action=\"dismiss-alert\" title=\""
    + alias2(helpers.gettext.call(alias1,"Dismiss",{"name":"gettext","hash":{},"data":data}))
    + "\">×</a>\n<span></span>\n</div>\n\n<div class=\"postbox\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showAvatar : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n<div class=\"textarea-wrapper\" "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.showAvatar : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\ndata-role=\"textarea\" dir=\"auto\">\n<div data-role=\"drag-drop-placeholder\" class=\"media-drag-hover\" style=\"display: none\">\n<div class=\"drag-text\">\n&#11015; "
    + alias2(helpers.gettext.call(alias1,"Drag and drop your images here to upload them.",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n</div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.displayMediaPreviews : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"edit-alert\" role=\"postbox-alert\"></div>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.showSubmitButton : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
